import consts from "@/consts"
import {getRangeByIntervals} from "@/lib/lib";

export default {
    state: {
        tracks_msgs_index: [],
        tracks_msgs: [],
    },
    actions: {
        clearUnitTracks({commit}, args = {}) {
            let unitId = args?.unitId
            commit('clearTracks', {unitId})
            commit('clearUnitsMsgs', {unitId})
            commit('clearUnitsMsgsGroupBy', {unitId})
            commit('clearTrips', {unitId})
            commit('clearParkings', {unitId})
            commit('clearStops', {unitId})
            commit('clearIdlings', {unitId})
        },
        reloadTracks({commit, dispatch}, args) {
            commit('clearTracks')
            return dispatch('fetchUnitsMsgs4Date', {date: 'today', ...args})
        },
        //sayHello() {}
    },
    mutations: {
        setTracksIndex(state, params) {
            let i = state.tracks_msgs_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.tracks_msgs_index.push(Object.freeze({...params}))
            } else {
                state.tracks_msgs_index[i] = Object.freeze({...state.tracks_msgs_index[i], ...params})
            }
        },
        storeTrack(state, nMsgs) {
            let changedField = 'time_received'
            nMsgs.sort((a, b) => a?.time?.utc - b?.time?.utc || a?.time_received - b?.time_received)
            nMsgs = nMsgs.reduce((msgs, m) => {
                let msg = msgs[m.xid_track]
                if (!msg || msg[changedField] <= m[changedField]) {
                    m = {...m}
                    delete m.xid;delete m.params;
                    msgs[m.xid_track] = m
                }
                return msgs;
            }, {})
            Object.values(nMsgs).forEach(function (nMsg) {
                let i = state.tracks_msgs.findIndex(msg => (msg.xid_track == nMsg.xid_track))
                if (i < 0) {
                    state.tracks_msgs.push(Object.freeze(nMsg))
                } else
                if (state.tracks_msgs[i][changedField] < nMsg[changedField]) {
                    // updateObjectByDiff(state.tracks_msgs[i], nMsg)
                    delete nMsg.xid_track
                    //let params = {...state.tracks_msgs[i].params, ...nMsg.params}
                    state.tracks_msgs[i] = Object.freeze({...state.tracks_msgs[i], ...nMsg})//, params
                }
            })
            state.tracks_msgs.sort((a, b) => a?.time?.utc - b?.time?.utc || a?.time_received - b?.time_received)
        },
        clearTracks(state, {unitId} = {}) {
            if (unitId) {
                state.tracks_msgs = state.tracks_msgs.filter(m => (m.unit_id || m.object_id) != unitId)
                state.tracks_msgs_index = state.tracks_msgs_index.filter(i => i.unitId != unitId)
            } else {
                state.tracks_msgs = [];
                state.tracks_msgs_index = [];
            }
        },
    },
    getters: {
        getTrackMsgs4Period: (state) => (unitId, timeFrom, timeTo) => {
            return state.tracks_msgs
                .filter(m => m.unit_id == unitId && timeFrom <= m.time.utc && m.time.utc <= timeTo && !m.no_coords)
        },
        getTrack4Period: (state, getters) => (unitId, timeFrom, timeTo) => {
            let msgs = state.tracks_msgs
                .filter(m => m.unit_id == unitId && timeFrom <= m.time.utc && m.time.utc <= timeTo && !m.no_coords)
            if (!msgs.length) return [];

            let trackSpeedColors = getters.getAppUserSettings?.trackSpeedColors || []
            let parkingColor = trackSpeedColors.find(r => r.from === 0)?.color || consts.trackSpeedColors.defColors[0]

            let parkings = getters.getParkings
                .filter(p => p.unit_id == unitId && timeFrom <= p.time_end.utc && p.time_start.utc <= timeTo)
            parkings.sort((a, b) => a?.time_start?.utc - b?.time_start?.utc)

            // let trips = getters.getTrips
            //     .filter(t => t.unit_id == unitId && timeFrom <= t.time_end.utc && t.time_start.utc <= timeTo)
            // trips.sort((a, b) => a?.time_start?.utc - b?.time_start?.utc)

            let parkingIdx = 0;
            let parking = parkings[parkingIdx];

            let parkingAdded = false;

            const result = [];
            for (const msg of msgs) {

                while (parking && msg.time.utc > parking.time_end.utc) {
                    parkingIdx++;
                    parking = parkings[parkingIdx];
                    parkingAdded = false;
                }

                if (parking && parking.time_start.utc <= msg.time.utc && msg.time.utc <= parking.time_end.utc) {
                    if (!parkingAdded) {
                        //parking
                        let pmsg = {...msg}
                        if (parking.coord_start.length) {
                            pmsg.latlng = {
                                lat: parking.coord_start[0],
                                lng: parking.coord_start[1]
                            }
                        }
                        pmsg.speed_color = parkingColor
                        result.push({
                            ...pmsg,
                        });
                        parkingAdded = true;
                    }
                    continue;
                }

                //moving
                let speed_range = getRangeByIntervals(msg.speed, trackSpeedColors)
                let speed_color = speed_range?.color || 'CCCCCC'
                result.push({
                    ...msg,
                    speed_color
                });
            }

            return result;
        },
        getTrack4Date: (state, getters) => (unitId, date) => {
            let msgs = state.tracks_msgs
                .filter(m => m.unit_id == unitId && m.time.date == date && !m.no_coords)
            if (!msgs.length) return [];

            let trackSpeedColors = getters.getAppUserSettings?.trackSpeedColors || []
            let parkingColor = trackSpeedColors.find(r => r.from == 0)?.color || consts.trackSpeedColors.defColors[0]

            let parkings = getters.getParkings
                .filter(p => p.unit_id == unitId && p.time_start.date == date)
            parkings.sort((a, b) => a?.time_start?.utc - b?.time_start?.utc)

            // let trips = getters.getTrips
            //     .filter(t => t.unit_id == unitId && t.time_start.date == date)
            // trips.sort((a, b) => a?.time_start?.utc - b?.time_start?.utc)

            let parkingIdx = 0;
            let parking = parkings[parkingIdx];

            let parkingAdded = false;

            const result = [];
            for (const msg of msgs) {

                while (parking && msg.time.utc > parking.time_end.utc) {
                    parkingIdx++;
                    parking = parkings[parkingIdx];
                    parkingAdded = false;
                }

                if (parking && parking.time_start.utc <= msg.time.utc && msg.time.utc <= parking.time_end.utc) {
                    if (!parkingAdded) {
                        //parking
                        let pmsg = {...msg}
                        if (parking.coord_start.length) {
                            pmsg.latlng = {
                                lat: parking.coord_start[0],
                                lng: parking.coord_start[1]
                            }
                        }
                        pmsg.speed_color = parkingColor
                        result.push({
                            ...pmsg,
                        });
                        parkingAdded = true;
                    }
                    continue;
                }

                //moving
                let speed_range = getRangeByIntervals(msg.speed, trackSpeedColors)
                let speed_color = speed_range?.color || 'CCCCCC'
                result.push({
                    ...msg,
                    speed_color
                });
            }

            return result;
        },
    }
}
